import {ViewState} from "../states";
import React, {forwardRef, ReactElement, useEffect, useState} from "react";
import {CloseCircleTwoTone, TableOutlined} from "@ant-design/icons";
import {Card, Skeleton, Tooltip} from "antd";
import {get} from "../core/request";
import $ from "jquery";
import {CustomButton} from "./buttons";
import {ContentBar} from "./contentBar";

interface AsyncTableProps {
    uuid: String,
    visibilityButton?: ReactElement<typeof CustomButton>,
}


export const AsyncTable = forwardRef(
    (props: AsyncTableProps, ref) => {
        const [state, setState] = useState(ViewState.loading);
        const [content, setContent] = useState(undefined);

        const [newContent, setNewContent] = useState(undefined);
        const [isBeingEdited, setIsBeingEdited] = useState(false);
        const [editableHead, setEditableHead] = useState();
        const [editableBody, setEditableBody] = useState();

        if (ref) {
            // @ts-ignore
            ref.current = {content}
        }

        useEffect(() => {
            query_api();
        }, [props.uuid])

        const breakLine = (s: string) => {
            if (typeof s === 'string') {
                return s.split('\n').map((line: string) => <>{line}<br/></>)
            }

            return s

        }

        const query_api = () => {
            get("reports/table/" + props.uuid)
                .done((response, status, jqXHR) => {
                    switch (jqXHR.status) {
                        case 200:
                            console.debug("AsyncTable Loaded:", response.data)
                            setContent(response.data.table);

                            setNewContent(response.data.table);
                            setEditableHead(response.data.table.head);
                            setEditableBody(response.data.table.body);
                            setState(ViewState.success);
                            return;
                        default:
                        case 202:
                            setTimeout(query_api, 3000, props);  // check again in 3 sec
                            return;
                    }
                })
                .fail((e) => {
                    console.error("AsyncTable Failed:", e);
                    setState(ViewState.failed);
                })
        }

        const Retry = () => {
            query_api();
        }

        switch (state) {
            case ViewState.loading:  //TODO update
                return <Skeleton.Node active><TableOutlined
                    style={{fontSize: 40, color: '#bfbfbf'}}/></Skeleton.Node>
            case ViewState.success:
                //@ts-ignore
                let head = content?.head;
                //@ts-ignore
                let body = content?.body;
                // @ts-ignore
                let spacing = content?.spacing?.replaceAll('|', ';').split(';');
                if (spacing[0] === '') {
                    spacing.shift()
                }
                if (spacing[spacing.length - 1] === '') {
                    spacing.pop()
                }
                if (spacing !== undefined) {
                    for (let i in spacing) {
                        // 'centering' in spacing[i]
                        if (spacing[i].includes('centering')) {
                            spacing[i] = 'c'
                        }
                    }
                }

                // @ts-ignore
                let idx = [...Array(head.length).keys()];

                // dict to map the column name to the alignment
                // @ts-ignore
                let align: [String] = []
                for (let i in idx) {
                    if (spacing === undefined || spacing[i] === undefined) {
                        align.push('left')
                    } else {
                        switch (spacing[i]) {
                            case 'r':
                                align.push('right')
                                break
                            case 'c':
                                align.push('center')
                                break
                            default:
                            case 'X':
                            case 'l':
                                align.push('left')
                                break
                        }
                    }
                }

                // @ts-ignore
                const max_width = $('#main-view')?.width() ? $('#main-view').width() - 96 : "30cm"

                const editTable = () => {
                    setIsBeingEdited(true)
                }

                const saveTable = () => {
                    setIsBeingEdited(false)
                    setContent(newContent)
                }

                const undoTableChanges = () => {
                    setIsBeingEdited(false);
                    setNewContent(content)
                    //@ts-ignore
                    setEditableHead(content.head)
                    //@ts-ignore
                    setEditableBody(content.body)
                }

                const handleChanges = (row: number, column: number, value: any) => {
                    // @ts-ignore
                    let updatedContent = {
                        // @ts-ignore
                        ...newContent,
                        // @ts-ignore
                        head: row === -1 ? newContent.head.map((headCell, headIndex) =>
                                headIndex === column ? value : headCell
                            // @ts-ignore
                        ) : newContent.head,
                        // @ts-ignore
                        body: newContent.body.map((rowData, rowIndex) =>
                        rowIndex === row ?
                        rowData.map((cell: any, columnIndex: number) =>
                        columnIndex === column ? value : cell)
                        : [...rowData])
                    }


                    // @ts-ignore
                    setNewContent(updatedContent);
                    // @ts-ignore
                    setEditableHead(updatedContent.head)
                    setEditableBody(updatedContent.body)
                    console.log(row, column, value)
                }

                return(
                    <Card type={"inner"}
                          bodyStyle={{
                              paddingLeft: '24px',
                              paddingRight: '24px',
                              paddingTop: '16px',
                              paddingBottom: '16px',
                          }}
                          style={
                        {
                            width: "100%",
                            maxWidth: max_width,
                            overflow: "hidden",
                        }
                    }
                          title={
                            isBeingEdited ?
                            <ContentBar>
                                <CustomButton mode={"delete"} onClick={undoTableChanges} tooltip={"Änderungen verwerfen"} toolbarItem={true}/>
                                <CustomButton mode={"save"} onClick={saveTable} tooltip={"Speichern"} toolbarItem={true}/>
                            </ContentBar> :
                            <ContentBar>
                                <CustomButton mode={"edit"} onClick={editTable} tooltip={"Bearbeiten"} toolbarItem={true}/>
                            </ContentBar>
                    }
                            extra={props.visibilityButton}>


                    {
                        // @ts-ignore
                        content?.title ? <h1 style={{width: '100%'}}>{
                            // @ts-ignore
                            content.title
                        }</h1> : <></>}

                    <div style={{
                        position: 'relative',
                        minWidth: "100%",
                        maxWidth: max_width,
                        overflowY: 'auto',
                        overflowX: 'auto',
                    }}>
                        <table className='reportTable' style={{
                            // @ts-ignore
                            width: idx.length > 5 ? "min(30cm, 100%)" : "min(21cm, 100%)",
                            maxWidth: idx.length > 5 ? "min(30cm, 100%)" : "min(21cm, 100%)",
                            overflowWrap: 'break-word',
                            margin: 'auto',
                            maxHeight: "100%",
                            borderCollapse: 'collapse',
                            tableLayout: 'auto',
                        }}>

                            { !isBeingEdited ?
                                (<>
                                    <thead>
                                    <tr>
                                        {
                                            // @ts-ignore
                                            idx.map((i: any) => <th
                                                style={{
                                                    // @ts-ignore
                                                    textAlign: align[i],
                                                    padding: '14px',
                                            }}>
                                                {//@ts-ignore
                                                    breakLine(head[i])}</th>)}
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {
                                        // @ts-ignore
                                        content?.body.map(
                                            (row: any) => <tr>
                                                {idx.map((i: any) => <td
                                                    style={{
                                                        // @ts-ignore
                                                        textAlign: align[i],
                                                        padding: "14px",
                                                    }}>{breakLine(row[i])}</td>)}
                                            </tr>
                                        )}
                                    </tbody>
                                </>) :
                                (
                                    <>
                                        <thead>
                                        <tr>
                                            {
                                                // @ts-ignore
                                                idx.map((i: any) => <th
                                                    style={{
                                                        // @ts-ignore
                                                        textAlign: align[i],
                                                        verticalAlign: "top",
                                                        padding: '14px',
                                                }
                                                }>

                                                    <textarea
                                                        //@ts-ignore
                                                        value={editableHead[i]}
                                                        onChange={(e) => {
                                                            e.target.style.height = 'auto';
                                                            e.target.style.height = e.target.scrollHeight + 'px';
                                                            handleChanges(-1, i, e.target.value);

                                                        }}

                                                        onInput={(e) => {
                                                            e.currentTarget.style.height = 'auto';
                                                            e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px';
                                                        }}

                                                        style={{
                                                            border: "none",
                                                            outline: "none",
                                                            boxShadow: "none",
                                                            background: "none",
                                                            cursor: "text",
                                                            fontSize: "1em",
                                                            fontWeight: "bold",
                                                            resize: "none",
                                                            boxSizing: "border-box",
                                                            width: '160px',

                                                        }}

                                                        ref={(el) => {
                                                            if (el) {
                                                                el.style.height = 'auto';
                                                                el.style.height = el.scrollHeight + 'px';
                                                                el.style.width = el.scrollWidth + 'px';
                                                            }
                                                        }}

                                                        wrap={"soft"}
                                                    />
                                                    </th>)
                                            }
                                        </tr>
                                        </thead>

                                        <tbody>
                                        {//@ts-ignore
                                            editableBody.map(
                                                (row: any, rowIndex: number) => <tr>
                                                    {idx.map((i: any) => <td
                                                        style={{
                                                            // @ts-ignore
                                                            textAlign: align[i],
                                                            verticalAlign: "top",
                                                            padding: '14px',
                                                        }}>
                                                        <textarea
                                                            value={row[i]}
                                                            onChange={(e) => {
                                                                e.target.style.height = 'auto';
                                                                e.target.style.height = e.target.scrollHeight + 'px';
                                                                handleChanges(rowIndex, i, e.target.value);
                                                            }}
                                                            onInput={(e) => {
                                                                e.currentTarget.style.height = 'auto';
                                                                e.currentTarget.style.height = e.currentTarget.scrollHeight + 'px';
                                                            }}
                                                            style={{
                                                                border: "none",
                                                                outline: "none",
                                                                boxShadow: "none",
                                                                background: "none",
                                                                cursor: "text",
                                                                fontSize: "1em",
                                                                resize: "none",
                                                                boxSizing: "border-box",
                                                                width: '160px',

                                                            }}
                                                            ref={(el) => {
                                                                if (el) {
                                                                    el.style.height = 'auto';
                                                                    el.style.height = el.scrollHeight + 'px';
                                                                }
                                                            }}

                                                            wrap={"soft"}
                                                        />
                                                        </td>)}
                                                </tr>
                                            )
                                        }
                                        </tbody>

                                    </>
                                )
            }
                        </table>
                    </div>
                        </Card>
                )
            case ViewState.failed:  //TODO update
            default:
                return <div
                    onClick={Retry}
                ><Tooltip title="Die Tabelle konnte nicht geladen werden. Bitte versuchen Sie es erneut.">
                    <Skeleton.Node><CloseCircleTwoTone twoToneColor="#F5222D"
                                                       style={{fontSize: 40}}/></Skeleton.Node></Tooltip></div>

        }
    }
)